import { educations } from '../../portfolio';
import ScrollReveal from '../ScrollReveal/ScrollReveal';
import './Education.css';
import EducationContainer from '../EducationContainer/EducationContainer';

const Education = () => {
  if (!educations.length) return null;

  return (
    <section id='education' className='section education'>
      <ScrollReveal>
        <h2 className='section__title'>Education</h2>
      </ScrollReveal>
      <ul className='education__list'>
        {educations.map((education, index) => (
          <ScrollReveal key={education.name} delay={index * 100}>
            <li className='education__list-item'>
              <EducationContainer education={education} />
            </li>
          </ScrollReveal>
        ))}
      </ul>
    </section>
  );
};

export default Education;
